import React from "react";

export default class Checkbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked:
        props.value !== undefined
          ? props.value
          : props.checked !== undefined
          ? props.checked
          : false,
    };
  }

  toggleChange = () => {
    var val = !this.state.isChecked;
    this.setState({
      isChecked: val,
    });

    // Supporta entrambe le props: onChange e onElementCheck per retrocompatibilità
    if (this.props.onChange) {
      this.props.onChange(val);
    } else if (this.props.onElementCheck) {
      this.props.onElementCheck(val);
    }
  };

  componentDidUpdate(prevProps) {
    // Aggiorna lo stato se il valore della prop cambia
    if (this.props.value !== prevProps.value) {
      this.setState({ isChecked: this.props.value });
    }
    if (this.props.checked !== prevProps.checked) {
      this.setState({ isChecked: this.props.checked });
    }
  }

  render() {
    return (
      <div style={mainClass}>
        <span style={name}>{this.props.name}</span>
        <input
          type="checkbox"
          checked={this.state.isChecked}
          onChange={this.toggleChange}
        />
      </div>
    );
  }
}

const mainClass = {
  padding: "10px",
};

const name = {
  marginRight: "10px",
};

const inputText = {
  width: "300px",
  padding: "10px",
};
